@font-face {
  font-family: "Visa Dialect";
  src: local("Visa Dialect");
  font-weight: 400;
}

@font-face {
  font-family: "Visa Dialect";
  src: local("Visa Dialect");
  font-weight: 500;
}

vs-card-editorial-grid {
  --text-dark: #161616;
  --text-medium: #6a6a6a;
  --text-light: #ffffff;
  --spacing-base: 1rem;
  display: block;
  font-family: "Visa Dialect", sans-serif;
}

.vs-card-editorial-grid {
  margin: 0 4rem; /* 48px */
  padding-bottom: 5rem; /* 80px - Add space between this component and the next component */
  @media (max-width: 480px) {
    padding-bottom: 3rem; /* 48px - Slightly less padding on smaller screens */
  }
}

/* Editorial Grid Responsive Margins */
.editorial-grid .grid {
  /* Default for small screens */
  margin-top: 30px;

  /* Medium screens: 768px to 991px */
  @media (min-width: 768px) and (max-width: 991px) {
    margin-top: 32px;
  }

  /* Large screens: 992px to 1199px */
  @media (min-width: 992px) and (max-width: 1199px) {
    margin-top: 39px;
  }

  /* Extra large screens: 1200px and above */
  @media (min-width: 1200px) {
    margin-top: 42px;
  }
}

/* Remove margin-top when vs-card-editorial-grid contains vsr-title-container with padding-vertical */
vs-card-editorial-grid:has(vsr-title .vsr-title-container.padding-vertical) .editorial-grid .grid {
  margin-top: 0;

  /* Ensure margin-top is removed for all screen sizes */
  @media (min-width: 768px) and (max-width: 991px),
    (min-width: 992px) and (max-width: 1199px),
    (min-width: 1200px) {
    margin-top: 0;
  }
}

.title-block {
  margin-top: calc(var(--spacing-base) * 5);
  .title-description-container {
    display: flex;
    // display: grid;
    // gap: calc(var(--spacing-base) * 2);
    // grid-template-columns: 1fr 1fr;
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  .title {
    margin: 0;
    font-size: 3.25rem; /* 52px */
    font-weight: 400;
    line-height: 1.2;
    color: var(--text-dark);
    border-bottom: none;
    padding-bottom: 0;
    @media (min-width: 481px) {
      flex: 0 0 50%;
      margin-bottom: 0;
    }

    @media (max-width: 1024px) {
      font-size: 2rem; /* 32px */
      font-weight: 400;
      line-height: 1.2;
    }
  }

  .description-container {
    max-width: 37.5rem; /* 600px */
    display: flex;
    flex-direction: column;
    @media (min-width: 481px) {
      flex: 0 0 50%;
    }
  }

  .description {
    font-size: 0.875rem; /* 14px */
    line-height: 1.5;
    color: var(--text-medium);
    margin-bottom: var(--spacing-base);
  }

  .link-button {
    background: transparent;
    border: none;
    padding: 0;
    font-size: 0.875rem; /* 14px */
    font-weight: 400;
    line-height: 1.5;
    color: var(--text-medium);
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 0.5rem; /* Add vertical space between text and underline */
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  .link-button {
    @media (max-width: 1024px) and (min-width: 481px) {
      display: none;
    }
  }
}

.title-block {
  @media (max-width: 1024px) {
    margin-top: calc(var(--spacing-base) * 3);
  }
}

/* Grid base styles */
.grid {
  display: grid;
  gap: calc(var(--spacing-base) * 2);
  margin-top: calc(var(--spacing-base) * 5);
  align-items: start;
  max-width: 1600px; /* Maximum width constraint */
  margin-left: auto; /* Center the grid */
  margin-right: auto; /* Center the grid */
}

/* Remove margin-top when vs-card-editorial-grid contains vsr-title-container with padding-vertical */
vs-card-editorial-grid:has(vsr-title .vsr-title-container.padding-vertical) .grid {
  margin-top: 0;
}

/* Desktop grid styles */
.desktop-grid {
  grid-template-columns: 1fr 1fr !important;

  /* Default styles for desktop grid */
  &.cards-4-or-less {
    height: auto; /* Auto height to accommodate all content */
    min-height: 50.625rem; /* Match hero card height */
    overflow-y: visible; /* No scrolling for 4 or fewer cards */
  }

  &.cards-more-than-4 {
    height: 70.625rem;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* For iOS devices */
    /* The grid itself doesn't scroll, the card-grid inside it will scroll */
    overflow-y: auto;

    /* Hide scrollbar while maintaining functionality */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

/* Mobile grid styles */
.mobile-grid {
  grid-template-columns: 1fr;
  gap: calc(var(--spacing-base) * 3);
  height: auto;
  max-height: none;
  overflow: visible;
  overflow-y: hidden !important;
  overflow-x: visible;
}

/* Tablet grid styles */
.tablet-grid {
  grid-template-columns: 1fr;
  gap: calc(var(--spacing-base) * 3);
  height: auto;
  max-height: none;
  overflow: visible;
  overflow-y: hidden !important;
  overflow-x: visible;
}

/* Tablet grid styles */
.tablet-grid {
  grid-template-columns: 1fr 1fr;
  gap: calc(var(--spacing-base) * 2);
  height: auto;
  max-height: none;
  overflow: visible;
  overflow-y: hidden !important;
  overflow-x: visible;
}

@media (max-width: 1024px) {
  .grid {
    margin-top: calc(var(--spacing-base) * 3);
  }

  /* Remove margin-top when vs-card-editorial-grid contains vsr-title-container with padding-vertical */
  vs-card-editorial-grid:has(vsr-title .vsr-title-container.padding-vertical) .grid {
    margin-top: 0;
  }
}

/* Tablet grid styles */
@media (max-width: 1024px) and (min-width: 481px) {
  .grid {
    margin-top: calc(var(--spacing-base) * 3);
  }

  /* Remove margin-top when vs-card-editorial-grid contains vsr-title-container with padding-vertical */
  vs-card-editorial-grid:has(vsr-title .vsr-title-container.padding-vertical) .grid {
    margin-top: 0;
  }
}

.editorial-hero-card {
  position: sticky;
  top: 0;
  overflow: hidden;
  height: 50.625rem; /* 810px */
  min-height: 25rem; /* 400px */
  background-color: #f0f0f0; /* Fallback color if image doesn't load */

  @media (max-width: 480px) {
    position: relative;
    height: auto;
    min-height: auto;
  }

  &.mobile-layout {
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100%;

    .image-container {
      height: 25rem; /* 400px */
      min-height: 18.75rem; /* 300px */
      width: 100%;
      border-radius: 0.5rem 0.5rem 0 0; /* 8px 8px 0 0 */
      cursor: pointer; /* Add cursor pointer to indicate clickable area */

      .image {
        border-radius: 0.5rem 0.5rem 0 0; /* 8px 8px 0 0 */
      }
    }

    .copy-container {
      position: relative;
      padding: calc(var(--spacing-base) * 2);
      background-color: #fff;
      color: var(--text-dark);
      width: 100%;
      box-sizing: border-box;

      .eyebrow,
      .title,
      .description,
      .text-link {
        color: var(--text-dark);
        text-shadow: none;
      }
    }
  }

  .image-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer; /* Add cursor pointer to indicate clickable area */
  }

  .image {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    display: block;
    transform: scale(1.07);
    transition: transform 1s ease; /* Add smooth transition for hover effect */
  }

  .video-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* For desktop devices - use hover */
  @media (hover: hover) and (pointer: fine) {
    &:hover .image {
      transform: scale(1); /* Image zooms out on hover */
    }
  }

  /* For touch devices - use active state */
  &:active .image {
    transform: scale(1); /* Image zooms out on tap */
  }

  .tint {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0.5rem; /* 8px */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.7) 100%);
  }

  .copy-container {
    position: absolute;
    padding: calc(var(--spacing-base) * 2);
    display: flex;
    flex-direction: column;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1;
    box-sizing: border-box;
  }

  .eyebrow {
    font-size: 0.75rem; /* 12px */
    font-weight: 500;
    line-height: 1.5;
    color: var(--text-light);
    margin-bottom: 0.5rem;
    text-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.7); /* 4px */
  }

  .title {
    font-size: 2rem; /* 32px */
    font-weight: 500;
    line-height: 1.28;
    color: var(--text-light);
    margin-bottom: 1rem;
    text-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.7); /* 4px */
  }

  .description {
    font-size: 0.875rem; /* 14px */
    font-weight: 500;
    line-height: 1.5;
    color: var(--text-light);
    margin-bottom: 0.5rem;
    text-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.7); /* 4px */
  }

  .text-link {
    display: flex;
    align-items: center;
    color: var(--text-light);
    text-decoration: none;
    font-size: 0.875rem; /* 14px */
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 0;
    text-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.7); /* 4px */

    .arrow-icon {
      margin-left: 0.5rem; /* 8px */
      width: 1rem; /* 16px */
      height: 1rem; /* 16px */
    }
  }

  .button-link {
    display: inline-block;
    width: fit-content;
    background-color: transparent;
    border: 1px solid rgba(200, 200, 200, 0.7); /* Gray border */
    color: var(--text-light);
    text-decoration: none;
    font-size: 0.875rem; /* 14px */
    line-height: 1.5;
    padding: 0.75rem 1.5rem;
    border-radius: 2rem;
    text-align: center;
    transition:
      border-color 0.5s ease,
      box-shadow 0.5s ease,
      text-shadow 0.5s ease;
    margin-top: 1rem;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 3D shadow effect */
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2); /* Subtle text shadow for 3D effect */
  }

  &:hover .button-link {
    border-color: var(--text-light); /* Change to white on card hover */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Enhanced shadow on card hover */
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.3); /* Enhanced text shadow on card hover */
  }
}

/* Desktop card grid styles */
@media (min-width: 481px) {
  .editorial-card-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: calc(var(--spacing-base) * 3);

    /* Default style for 4 or fewer cards - no scroll */
    &.cards-4-or-less {
      max-height: none; /* Allow full height to show all content */
      overflow-y: visible;
    }

    /* Style for more than 4 cards - enable scroll */
    &.cards-more-than-4 {
      max-height: calc(
        25rem * 4 + (var(--spacing-base) * 2 * 3)
      ); /* Height for 4 cards (25rem each) + gaps (3 gaps * 2rem) */
      overflow-y: auto; /* Enable scrolling when content exceeds max-height */

      /* Hide scrollbar while maintaining functionality */
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

/* Mobile card grid styles */
@media (max-width: 480px) {
  .editorial-card-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: calc(var(--spacing-base) * 2);
    max-height: none;
    overflow: visible;
    overflow-y: visible;
  }
}

/* Tablet card grid styles */
@media (min-width: 480px) {
  .editorial-card-grid {
    grid-template-columns: repeat(2, 300px);
  }
}

/* Wrapper for both vsr-card and legacy card components */
.vs-card-editorial-grid .card-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  /* Ensure vsr-card integrates properly with the grid layout - scoped to editorial grid only */
  vsr-card {
    height: 100%;

    .vsr-card {
      max-width: none; /* Override the 300px max-width from vsr-card to fit grid */
    }
  }
}

.card {
  background-color: transparent !important;
  border: none !important;
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1rem;

  .container {
    position: relative;
    padding-bottom: 133.33%; // 3:4 aspect ratio
    overflow: hidden;
    cursor: pointer; /* Add cursor pointer to indicate clickable area */
  }

  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    transform: scale(1);
    transition: transform 0.8s ease; /* Add smooth transition for hover effect */
  }

  .video-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1);
    transition: transform 0.8s ease;
  }

  /* For desktop devices - use hover */
  @media (hover: hover) and (pointer: fine) {
    &:hover .image {
      transform: scale(1.07); /* Image zooms in on hover */
    }
  }

  /* For touch devices - use active state */
  &:active .image {
    transform: scale(1.07); /* Image zooms in on tap */
  }

  .copy-container {
    flex: 1;
  }

  .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: calc(var(--spacing-base) * 0.5);
  }

  .title {
    font-size: 1.25rem; /* 20px */
    font-weight: 400;
    line-height: 1.3;
    color: var(--text-dark);
    margin: 0;
    transition: color 0.2s ease;
  }

  &:hover {
    .title {
      color: #1434cb;
    }

    .title-link .title {
      color: #1434cb;
    }

    .title-arrow-icon {
      display: block;
    }
  }

  .title-link {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: inherit;

    &:hover .title {
      color: #1434cb;
    }

    .title {
      color: var(--text-dark);
      margin: 0;
    }
  }

  .title-arrow-link {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title-arrow-icon {
    display: none; /* Hide arrow icon by default */
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }

  .description {
    font-size: 0.875rem; /* 14px */
    line-height: 1.5;
    color: var(--text-medium);
  }
}

// Mobile view specific styles
.vs-card-editorial-grid.mobile-view {
  margin: 0; /* Full bleed in mobile view */
  .vsr-title-container {
    margin: 0 24px; /* 24px margin as requested */
  }
  .title-block {
    /* Custom styles for vsr-title-headline in card editorial grid */
    vsr-title .vsr-title-headline {
      font-size: 32px; /* Mobile font size */
    }

    .title-description-container {
      display: flex;
      flex-direction: column;
      gap: calc(var(--spacing-base) * 1);
    }

    .description-container {
      display: flex;
      flex-direction: column;
      gap: calc(var(--spacing-base) * 1);
    }

    .link-button {
      display: inline-block;
      margin-top: calc(var(--spacing-base) * 0.5);
      text-align: left;
    }
  }

  .grid,
  .mobile-grid {
    display: flex;
    flex-direction: column;
    overflow: visible;
    overflow-y: visible;
    overflow-x: visible;
    height: auto;
    max-height: none;

    .editorial-hero-card {
      order: 1;
      margin-bottom: calc(var(--spacing-base) * 2);

      &.mobile-layout {
        display: flex;
        flex-direction: column;
        width: 100%;

        .image-container {
          height: 25rem; /* 400px */
          min-height: 18.75rem; /* 300px */
          width: 100%;
          border-radius: 0.5rem 0.5rem 0 0; /* 8px 8px 0 0 */

          .image {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            border-radius: 0.5rem 0.5rem 0 0; /* 8px 8px 0 0 */
            transform: scale(1.07);
            transition: transform 1s ease; /* Add smooth transition for hover effect */
          }
        }

        /* For desktop devices - use hover */
        @media (hover: hover) and (pointer: fine) {
          &:hover .image {
            transform: scale(1); /* Image zooms out on hover */
          }
        }

        /* For touch devices - use active state */
        &:active .image {
          transform: scale(1); /* Image zooms out on tap */
        }

        .copy-container {
          position: relative;
          bottom: auto;
          left: auto;
          background-color: #fff;
          padding: calc(var(--spacing-base)) 24px;
          width: 100%;
          box-sizing: border-box;
          padding-bottom: 0;
          .eyebrow {
            color: var(--text-dark);
            text-shadow: none;
            font-size: 0.75rem; /* 12px */
          }

          .title {
            color: var(--text-dark);
            text-shadow: none;
            font-size: 1.5rem; /* 24px */
          }

          .description {
            color: var(--text-medium);
            text-shadow: none;
            display: block;
            font-size: 0.875rem; /* 14px */
          }

          .text-link,
          .button-link {
            color: var(--text-dark);
            text-shadow: none;
            font-size: 0.875rem; /* 14px */
          }

          .button-link {
            border-color: rgba(100, 100, 100, 0.7); /* Gray border */
            margin-top: 0.5rem;
            padding: 0.75rem 1.5rem;
            width: fit-content;
            white-space: nowrap;
            border-radius: 2rem;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 3D shadow effect */
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2); /* Subtle text shadow for 3D effect */
            transition:
              border-color 0.5s ease,
              box-shadow 0.5s ease,
              text-shadow 0.5s ease;
          }

          /* For desktop devices - use hover */
          @media (hover: hover) and (pointer: fine) {
            &:hover .button-link {
              border-color: var(--text-dark); /* Change to dark on card hover */
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Enhanced shadow on card hover */
              text-shadow: 0 2px 2px rgba(0, 0, 0, 0.3); /* Enhanced text shadow on card hover */
            }
          }

          /* For touch devices - use active state */
          &:active .button-link {
            border-color: var(--text-dark); /* Change to dark on card tap */
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Enhanced shadow on card tap */
            text-shadow: 0 2px 2px rgba(0, 0, 0, 0.3); /* Enhanced text shadow on card tap */
          }
        }
      }
    }

    .mobile-carousel {
      order: 2;
      width: 100%;
      position: relative;

      .nav-button {
        position: absolute;
        top: 12.5rem; /* Half of the image height (25rem / 2) to center on images */
        transform: translateY(-50%);
        z-index: 10;
        width: 3rem; /* 48px */
        height: 3rem; /* 48px */
        border: 1px solid #e0e0e0;
        border-radius: 50%; /* Fully round border */
        background-color: rgba(255, 255, 255, 0.9); /* Semi-transparent white */
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        backdrop-filter: blur(4px); /* Add blur effect for better visibility over images */

        &:hover:not(.disabled) {
          border-color: #1434cb;
          color: #1434cb;
          background-color: rgba(255, 255, 255, 1); /* Solid white on hover */
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        &:active:not(.disabled) {
          transform: translateY(-50%) scale(0.95);
        }

        &.disabled {
          opacity: 0.4;
          cursor: not-allowed;
          border-color: #e0e0e0;
          color: #999;
          background-color: rgba(255, 255, 255, 0.7);
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
        }

        &.prev-button {
          left: 2rem; /* Position on the left side over the image */
        }

        &.next-button {
          right: 1.5rem; /* Position on the right side over the image */
        }

        svg {
          width: 24px;
          height: 24px;
        }
      }

      .scrollable-cards {
        width: calc(100% - 24px); /* Adjust width to account for left margin */
        display: flex;
        overflow-x: auto;
        /* Remove scroll-snap for manual navigation */
        scroll-snap-type: none;
        -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
        scrollbar-width: none; /* Hide scrollbar in Firefox */
        -ms-overflow-style: none; /* Hide scrollbar in IE/Edge */
        padding: 0.5rem 0; /* Add vertical padding */
        margin-left: 24px; /* 24px left margin as requested */

        /* Hide scrollbar in Chrome/Safari */
        &::-webkit-scrollbar {
          display: none;
        }

        .mobile-card {
          flex: 0 0 80%; /* Card takes 80% of container width, showing a peek of adjacent cards */
          /* Remove scroll-snap-align for manual navigation */
          display: flex;
          flex-direction: column;
          margin-right: 1rem; /* Space between cards */

          .image-container {
            width: 100%;
            height: 25rem; /* 400px */
            max-width: 100%; /* Allow full width within the card */
            position: relative;
            overflow: hidden;
            border-radius: 0.5rem; /* 8px */
            background-color: #f0f0f0; /* Fallback color if image doesn't load */
            display: block;

            .image {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center;
              display: block;
              transform: scale(1);
              transition: transform 1s ease; /* Add smooth transition for hover effect */
            }

            .video-container {
              width: 100%;
              height: 100%;
              overflow: hidden;
              position: relative;
            }

            .video {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transform: scale(1);
              transition: transform 1s ease;
            }
          }

          /* For desktop devices - use hover */
          @media (hover: hover) and (pointer: fine) {
            &:hover .image {
              transform: scale(1.07); /* Image zooms in on hover */
            }
          }

          /* For touch devices - use active state */
          &:active .image {
            transform: scale(1.07); /* Image zooms in on tap */
          }

          .copy-container {
            padding: 1rem 0;
            margin-top: 0.5rem; /* Add space between image and copy container to prevent overlapping */
            position: relative; /* Ensure proper stacking context */
            z-index: 1; /* Ensure copy container appears above image */

            .title-container {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 0.5rem;
              width: 100%;
            }

            .title {
              font-size: 1.25rem; /* 20px */
              font-weight: 400;
              line-height: 1.3;
              color: var(--text-dark);
              margin: 0;
              transition: color 0.2s ease;
            }

            &:hover {
              .title {
                color: #1434cb;
              }

              .title-link .title {
                color: #1434cb;
              }

              .title-arrow-icon {
                display: block;
              }
            }

            .title-link {
              text-decoration: none;
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              color: inherit;

              &:hover .title {
                color: #1434cb;
              }

              .title {
                color: var(--text-dark);
                margin: 0;
              }
            }

            .title-arrow-link {
              text-decoration: none;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .title-arrow-icon {
              display: none; /* Hide arrow icon by default */
              width: 16px;
              height: 16px;
              margin-left: 8px;
            }

            .description {
              font-size: 0.875rem; /* 14px */
              line-height: 1.5;
              color: var(--text-medium);
            }
          }
        }
      }
    }
  }
}

// Tablet view specific styles (768px - 991px)
.vs-card-editorial-grid.tablet-view {
  .title-block {
    padding: 0 calc(var(--spacing-base) * 2); /* 32px - More padding for tablet */

    /* Custom styles for vsr-title-headline in card editorial grid */
    vsr-title .vsr-title-headline {
      font-size: 40px; /* Tablet font size */
    }

    .title-description-container {
      display: flex;
      flex-direction: column;
      gap: calc(var(--spacing-base) * 1.5);
    }

    .description-container {
      display: flex;
      flex-direction: column;
      gap: calc(var(--spacing-base) * 1);
    }

    .link-button {
      display: inline-block;
      margin-top: calc(var(--spacing-base) * 0.5);
      text-align: left;
    }
  }

  .grid,
  .tablet-grid {
    display: flex;
    flex-direction: column;
    overflow: visible;
    overflow-y: visible;
    overflow-x: visible;
    height: auto;
    max-height: none;

    .editorial-hero-card {
      order: 1;
      margin-bottom: calc(var(--spacing-base) * 3);

      &.tablet-layout {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;

        .image-container {
          height: 30rem; /* 480px - Larger for tablet */
          min-height: 25rem; /* 400px */
          width: 100%;
          border-radius: 0.5rem 0.5rem 0 0; /* 8px 8px 0 0 */

          .image {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            border-radius: 0.5rem 0.5rem 0 0; /* 8px 8px 0 0 */
            transform: scale(1.07);
            transition: transform 1s ease;
          }
        }

        /* For desktop devices - use hover */
        @media (hover: hover) and (pointer: fine) {
          &:hover .image {
            transform: scale(1); /* Image zooms out on hover */
          }
        }

        /* For touch devices - use active state */
        &:active .image {
          transform: scale(1); /* Image zooms out on tap */
        }

        .copy-container {
          position: relative;
          bottom: auto;
          left: auto;
          background-color: #fff;
          padding: calc(var(--spacing-base) * 2);
          width: 100%;
          box-sizing: border-box;

          .eyebrow {
            color: var(--text-dark);
            text-shadow: none;
            font-size: 0.875rem; /* 14px */
          }

          .title {
            color: var(--text-dark);
            text-shadow: none;
            font-size: 2rem; /* 32px */
          }

          .description {
            color: var(--text-dark);
            text-shadow: none;
            display: block;
            font-size: 1rem; /* 16px */
          }

          .text-link,
          .button-link {
            color: var(--text-dark);
            text-shadow: none;
            font-size: 1rem; /* 16px */
          }

          .button-link {
            border-color: rgba(100, 100, 100, 0.7);
            margin-top: 1rem;
            padding: 1rem 2rem;
            width: fit-content;
            white-space: nowrap;
            border-radius: 2rem;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
            transition:
              border-color 0.5s ease,
              box-shadow 0.5s ease,
              text-shadow 0.5s ease;
          }

          /* For desktop devices - use hover */
          @media (hover: hover) and (pointer: fine) {
            &:hover .button-link {
              border-color: var(--text-dark);
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
              text-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
            }
          }

          /* For touch devices - use active state */
          &:active .button-link {
            border-color: var(--text-dark);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
            text-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
          }
        }
      }
    }

    .tablet-carousel {
      order: 2;
    }
  }

  .tablet-carousel {
    width: 100%;
    position: relative;

    .nav-button {
      position: absolute;
      top: 15rem; /* Half of the tablet image height (30rem / 2) to center on images */
      transform: translateY(-50%);
      z-index: 10;
      width: 3.5rem; /* 56px - Larger for tablet */
      height: 3.5rem; /* 56px */
      border: 1px solid #e0e0e0;
      border-radius: 50%; /* Fully round border */
      background-color: rgba(255, 255, 255, 0.9);
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      backdrop-filter: blur(4px);

      &:hover:not(.disabled) {
        border-color: #1434cb;
        color: #1434cb;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }

      &:active:not(.disabled) {
        transform: translateY(-50%) scale(0.95);
      }

      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
        border-color: #e0e0e0;
        color: #999;
        background-color: rgba(255, 255, 255, 0.7);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
      }

      &.prev-button {
        left: 2rem; /* Position on the left side over the image */
      }

      &.next-button {
        right: 2rem; /* Position on the right side over the image */
      }

      svg {
        width: 28px; /* Slightly larger for tablet */
        height: 28px;
      }
    }

    .scrollable-cards {
      width: 100%;
      display: flex;
      overflow-x: auto;
      scroll-snap-type: none;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding: 1rem 0;

      /* Hide scrollbar in Chrome/Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      .tablet-card {
        flex: 0 0 48%; /* Card takes 48% of container width, showing 2 cards per frame with gap */
        display: flex;
        flex-direction: column;
        margin-right: 1.5rem; /* Space between cards */

        .image-container {
          width: 100%;
          height: 30rem; /* 480px - Larger for tablet */
          max-width: 100%;
          position: relative;
          overflow: hidden;
          border-radius: 0.5rem;
          background-color: #f0f0f0;
          display: block;

          .image {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            display: block;
            transform: scale(1);
            transition: transform 1s ease;
          }

          .video-container {
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;
          }

          .video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transform: scale(1);
            transition: transform 1s ease;
          }
        }

        /* For desktop devices - use hover */
        @media (hover: hover) and (pointer: fine) {
          &:hover .image {
            transform: scale(1.07);
          }
        }

        /* For touch devices - use active state */
        &:active .image {
          transform: scale(1.07);
        }

        .copy-container {
          padding: 1.5rem 0;
          margin-top: 1rem;
          position: relative;
          z-index: 1;

          .title-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 1rem;
            width: 100%;
          }

          .title {
            font-size: 1.5rem; /* 24px - Larger for tablet */
            font-weight: 400;
            line-height: 1.3;
            color: var(--text-dark);
            margin: 0;
            transition: color 0.2s ease;
          }

          &:hover {
            .title {
              color: #1434cb;
            }

            .title-link .title {
              color: #1434cb;
            }

            .title-arrow-icon {
              display: block;
            }
          }

          .title-link {
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            color: inherit;

            &:hover .title {
              color: #1434cb;
            }

            .title {
              color: var(--text-dark);
              margin: 0;
            }
          }

          .title-arrow-link {
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .title-arrow-icon {
            display: none;
            width: 20px; /* Larger for tablet */
            height: 20px;
            margin-left: 10px;
          }

          .description {
            font-size: 1rem; /* 16px - Larger for tablet */
            line-height: 1.5;
            color: var(--text-medium);
          }
        }
      }
    }
  }
}
